import React from 'react';
import cx from 'classnames';
import Box from '../../../layout/box';
import ValueManager from '../../../valuemanager';
import Checkbox from '../../../checkbox';
import { eventToFieldActionUpdateRequest, getDataDescForTextField } from '../util';

const BooleanEditor = React.memo(
	({label = 'Boolean Value', value, className, dataDescriptor, ...props}) => {
		const { label: descLabel, ...restFieldProps } = getDataDescForTextField(dataDescriptor);

		return (
			<Box className={cx(className)}>
				<ValueManager value={value} valueField="checked" onChange={eventToFieldActionUpdateRequest(props, 'target.checked')}>
					<Checkbox label={descLabel || label} color="primary" {...restFieldProps} />
				</ValueManager>
			</Box>
		);
	}
);

export default BooleanEditor;